(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["su-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-su-quick-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button');
    const label = form.querySelector('[data-su-quick-add-label]');
    const original = label.textContent;
    const root = window.Shopify?.routes?.root || '/';
    button.disabled = true;

    try {
      const added = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!added.ok) throw new Error('add failed');

      const cart = await (await fetch(`${root}cart.js`)).json();
      document.querySelectorAll('.su-nav__count').forEach((count) => {
        count.textContent = cart.item_count;
      });
      label.textContent = button.dataset.labelAdded;
    } catch {
      label.textContent = button.dataset.labelError;
    }

    setTimeout(() => {
      label.textContent = original;
      button.disabled = false;
    }, 1800);
  });
  } catch(e) { console.error(e); }
})();

})();
